import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from 'redux/store';
import { updatePageStatus } from 'redux/actions/ui.action';
import background from 'static/images/bounty-header.png';
import unverified from 'static/images/mvp/unverified.png';
import verifying from 'static/images/mvp/verifying.png';
import rejected from 'static/images/mvp/rejected.png';
import qrVerify from 'static/images/mvp/qr_verify.png';
import Section from 'views/components/core/Section';
import './custom-home.scss';
import CardMvpSession from '../../components/core/CardSession';
import Auth from '@aws-amplify/auth';
import ReactGA from 'react-ga';
import { Modal as ModalPopup, ModalHeader } from 'react-bootstrap';

import { getSessions, fetchNeedEvaluateSessions } from 'redux/actions/mvp/session.action';
import { PageHero, PageLoader } from '@kambria/kambria-lego';

import config from 'config';
import Pagination from '../../components/core/Pagination';
import { I18n } from '../../../helpers/i18n';
import removeSessionImage from '../../../static/images/mvp/remove-session.png';
import RatingFloatNotification from '../../components/core/RatingFloatNotification';

class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      visibleMembershipModal: false,
      currentPage: 1,
      totalRecords: 0,
      pageLimit: 40,
      listSessions: [],
      showVerifyModal: false,
      pendingRatingSession: null,
    };
  }

  style = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };

  openMembershipModal = () => {
    if (!localStorage.getItem('popupModal') || localStorage.getItem('popupModal') === 'true') {
      this.setState({ visibleMembershipModal: true });
      localStorage.setItem('popupModal', 'true');
    }
  };

  openVerifyModal = () => {
    this.setState({ showVerifyModal: true });
  };

  closeVerifyModal = () => {
    this.setState({ showVerifyModal: false });
  };

  async componentDidMount() {
    document.title = `TECD - ${I18n.t('tecd_slogan')}`;
    this.props.updatePageStatus('loading');
    const { getSessions } = this.props;
    const sessions = await getSessions();

    if (sessions.success) {
      const data = sessions.data.data;
      const listSessions = data.list;
      this.setState({
        listSessions,
        currentPage: data.currentPage,
        totalRecords: Number(data.total),
      });
    }
    this.props.updatePageStatus('loaded');
    this.fetchPendingRatingSession();

    let cred = await Auth.currentUserCredentials();

    if (!cred || !cred.authenticated) this.openMembershipModal();
  }

  fetchPendingRatingSession = async () => {
    const { user } = this.props;
    if (!user?._id && !user?.id) return;
    try {
      const data = await fetchNeedEvaluateSessions()();
      if (data && data.length > 0) {
        this.setState({ pendingRatingSession: data[0] });
      }
    } catch (err) {
      console.log('fetchPendingRatingSession error', err);
    }
  };

  onPageChanged = async ({ currentPage }) => {
    this.setState({ currentPage });
    const { getSessions } = this.props;

    const sessions = await getSessions(currentPage);

    if (sessions.success) {
      const data = sessions.data.data;
      const listSessions = data.list;
      this.setState({
        listSessions,
        currentPage: data.currentPage,
        totalRecords: Number(data.total),
      });
    }
  };

  changeStandardTextColor = (e) => {
    e.target.style.color = '#00edc3';
  };
  changeRevertTextColor = (e) => {
    e.target.style.color = 'white';
  };

  checkStatusVerified = () => {
    if (user && user.statusVerify !== 'verified') {
      e.preventDefault();
    }
  };

  checkUserStatusVerify = () => {
    const { user } = this.props;
    // The API always sends statusVerify (schema default is 'need_to_verify'), so a missing
    // value means the profile has not loaded yet and we must not warn the user.
    return user?.statusVerify || 'verified';
  };

  getWarningTitle = () => {
    // return I18n.t('identity_rejected');
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return I18n.t('need_verify_identity');
    }
    if (status === 'verifying') {
      return I18n.t('verifying_identity');
    }
    if (status === 'reject') {
      return I18n.t('identity_rejected');
    }
    return '';
  };

  getWarningContent = () => {
    // return I18n.t('rejected_content');
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return I18n.t('verify_identity_warning');
    }
    if (status === 'verifying') {
      return I18n.t('verifying_content');
    }
    if (status === 'reject') {
      return I18n.t('rejected_content');
    }
    return '';
  };

  getVerifyButtonLabel = () => {
    // return I18n.t('verify_again');
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return I18n.t('verify_now');
    }
    if (status === 'verifying') {
      return I18n.t('verify_again');
    }
    if (status === 'reject') {
      return I18n.t('verify_again');
    }
    return '';
  };

  getVerifyIcon = () => {
    // return rejected;
    const status = this.checkUserStatusVerify();
    if (status === 'need_to_verify') {
      return unverified;
    }
    if (status === 'verifying') {
      return verifying;
    }
    if (status === 'reject') {
      return rejected;
    }

    return '';
  };

  getAlertBackgroundColor = () => {
    // return '#FFF5F6';
    const status = this.checkUserStatusVerify();
    switch (status) {
      case 'need_to_verify':
        return '#FFFAEC';
      case 'verified':
        return '#f0f9ff';
      case 'verifying':
        return '#ECF4FF';
      case 'reject':
        return '#FFF5F6';
      default:
        return '#fefefe';
    }
  };

  render() {
    const { totalRecords, pageLimit, listSessions } = this.state;
    const warningTitle = this.getWarningTitle();
    const warningContent = this.getWarningContent();
    const verifyButtonLabel = this.getVerifyButtonLabel();
    const verifyIcon = this.getVerifyIcon();
    const alertBackgroundColor = this.getAlertBackgroundColor();
    const kambria =
      I18n.language === 'vi'
        ? 'https://kambria.io/docs/tecd-vi/tong-quan-ve-tecd/?full=1'
        : 'https://kambria.io/docs/tecd-en/overview-of-tecd/?full=1';
    return (
      <div id="site_wrapper">
        <div className="site-upper" style={this.style}>
          {this.props.header}
          <PageHero headline="TECD" description={I18n.t('tecd_slogan')} />
        </div>
        <main className="main">
          <div className="container">
            {warningTitle && (
              <div
                className=""
                style={{
                  padding: '10px',
                  marginTop: '10px',
                  backgroundColor: alertBackgroundColor,
                  border: '1px solid #ffeaa7',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '15px',
                  marginBottom: '0px !important',
                }}
              >
                <div
                  style={{
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    marginTop: '2px',
                  }}
                >
                  <img
                    src={verifyIcon}
                    alt="Warning"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '400', color: '#111827', marginBottom: '8px', fontSize: '16px' }}>
                    {warningTitle}
                  </div>
                  <div style={{ color: '#6B7280', marginBottom: '8px', fontSize: '14px', lineHeight: '1.4' }}>
                    {warningContent}
                  </div>
                  <div
                    style={{ color: '#111827', textDecoration: 'underline', cursor: 'pointer', fontSize: '14px' }}
                    onClick={this.openVerifyModal}
                  >
                    {verifyButtonLabel}
                  </div>
                </div>
              </div>
            )}
            <div style={{ paddingTop: '44px' }}>
              <div className="iframe-container">
                <iframe
                  src={kambria}
                  name="myiFrame"
                  id="myIframe"
                  scrolling="yes"
                  marginHeight="0px"
                  marginWidth="0px"
                  allowFullScreen
                  style={{ border: 'none', width: '100%', height: '686px' }}
                />
              </div>
            </div>
            <PageLoader loading={!listSessions} />
            {listSessions && (
              <Section title="" url="/" className="card-section">
                <div className="row">
                  {listSessions.map((item, index) => {
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <CardMvpSession key={index} data={item} status={item.status} url={config.sites.bounty} />
                      </div>
                    );
                  })}
                </div>

                <Pagination
                  totalRecords={totalRecords}
                  pageLimit={pageLimit}
                  pageNeighbours={1}
                  onPageChanged={this.onPageChanged}
                />
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}

        <ModalPopup
          size="sm"
          show={this.state.showVerifyModal}
          onHide={this.closeVerifyModal}
          id="remove-session-modal"
          style={{ opacity: 1 }}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <ModalHeader>
            <a
              type="button"
              className="close-button-forget"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.closeVerifyModal}
            >
              x
            </a>
          </ModalHeader>
          <ModalPopup.Body>
            {/* QR Code */}
            <div style={{ marginBottom: '20px' }}>
              <div
                style={{
                  width: '200px',
                  height: '200px',
                  backgroundColor: 'white',
                  margin: '0 auto',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '10px',
                }}
              >
                <img
                  src={qrVerify}
                  alt="QR Code"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            </div>

            {/* Title */}
            <h3
              style={{
                color: 'white',
                marginBottom: '15px',
                fontSize: '20px',
                fontWeight: '600',
              }}
            >
              {I18n.t('become_verified_partner')}
            </h3>

            {/* Description */}
            <p
              style={{
                color: '#D1D5DB',
                marginBottom: '25px',
                fontSize: '14px',
                lineHeight: '1.5',
              }}
            >
              {I18n.t('verify_modal_description')}
            </p>
          </ModalPopup.Body>
        </ModalPopup>

        {/* Verify Identity Modal */}
        {this.state.pendingRatingSession && (
          <RatingFloatNotification
            session={this.state.pendingRatingSession}
            onDismiss={() => this.setState({ pendingRatingSession: null })}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bounties: state.bounty,
  products: state.product,
  ui: state.ui,
  user: state.user,
  saleCampaigns: state.saleCampaign,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSessions,
      updatePageStatus,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
